/**
 * Runs an interval until the condition evaluates to true. Then runs the
 * handler parameter.
 *
 * @param {function} condition
 * @param {function} handler
 * @param {number|null} delay
 */
export default (
  condition: () => boolean,
  handler: Function,
  delay: number = 1000,
  giveUpTime: number | undefined = undefined
) => {
  const startTime = Date.now();
  let interval = setInterval(() => {
    const conditionMet = condition();
    if (!conditionMet) {
      if (
        typeof giveUpTime === "number" &&
        Date.now() - startTime >= giveUpTime
      ) {
        clearInterval(interval);
      }
      return false;
    }
    handler();
    clearInterval(interval);
  }, delay);
  return interval;
};
